import { render, staticRenderFns } from "./settings-expand.vue?vue&type=template&id=65e83cd6&"
import script from "./settings-expand.vue?vue&type=script&lang=js&"
export * from "./settings-expand.vue?vue&type=script&lang=js&"
import style0 from "./settings-expand.vue?vue&type=style&index=0&id=65e83cd6&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports